import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, drawRectangle, getTextColor, getTrimmedText} from '../../canvas-timeline/canvas_timeline_util';
import Util from '../../../../forecast-app/shared/util/util';
class ProjectAllocationItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PROJECT_SCHEDULING_PROJECT_ALLOCATION, data);
	}

	draw(canvasContext, x, y, width, canvasWidth) {
		const {data, height} = this;
		const {color, totalHours, allocation, intl} = data;
		const textColor = getTextColor(color);
		drawRectangle(canvasContext, x, y + 2, width, height - 4, {
			backgroundColor: color,
			backgroundOpacity: 0.9,
			borderRadius: 10,
		});

		let showPerDayText = true;
		let minutesPerDay = null;
		const dayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
		for (const dayName of dayNames) {
			if (allocation[dayName]) {
				if (minutesPerDay) {
					if (allocation[dayName] !== minutesPerDay) {
						showPerDayText = false;
						break;
					}
				} else {
					minutesPerDay = allocation[dayName];
				}
			}
		}

		canvasContext.fillStyle = textColor;
		canvasContext.font = '400 12px ' + Util.getFontFamily();
		let text = '';
		if (showPerDayText) {
			text += `${intl.formatMessage({id: 'scheduling.time_per_day'}, {time: Util.convertMinutesToFullHour(minutesPerDay, intl)})} | `;
		}
		text += Util.convertMinutesToFullHour(totalHours * 60, intl);
		const textWidth = canvasContext.measureText(text).width;
		const textMargin = 16;
		const textXCoord = x + width > canvasWidth ? canvasWidth - (textMargin + textWidth) : x + width - (textMargin + textWidth);
		if (width > 32 && x + 16 < textXCoord) {
			const textColor = getTextColor(color);
			canvasContext.fillStyle = textColor;
			const formattedTaskName = getTrimmedText(canvasContext, text, width - 32);
			canvasContext.fillText(formattedTaskName, textXCoord, y + 21);
			// Show name of allocation
			if (allocation.idleTimeName || allocation.displayName) {
				const textMargin = 16;
				const visibleItemStartX = x > 0 ? x : 0;
				const visibleItemEndX = x + width > canvasWidth ? canvasWidth : x + width;
				const visibleItemWidth = visibleItemEndX - visibleItemStartX;
				canvasContext.fillText(getTrimmedText(canvasContext, allocation.idleTimeName || allocation.displayName, visibleItemWidth - textMargin * 2 - textWidth - 20), textMargin + visibleItemStartX, y + 21);
			}
		}
	}
}
export default ProjectAllocationItem;
